<template>
  <span class="hl-tag" v-if="!plain" :style="{ backgroundColor, color }">
    <slot />
  </span>
  <span class="hl-tag hl-tag-plain" v-else :style="{ borderColor, color }">
    <slot />
  </span>
</template>

<script>
export default {
  props: {
    // 表示没有背景颜色，只有边框
    plain: {
      type: Boolean,
      default: false
    },
    backgroundColor: {
      type: String,
      default: '#ffffff'
    },
    color: {
      type: String,
      default: '#ffffff'
    },
    borderColor: {
      type: String
    }
  }
}
</script>
<style lang="scss" scoped>
.hl-tag {
  background: #8b73f8;
  border-radius: 10px;
  padding: 2px 6px;
  font-size: 12px;
  color: #ffffff;
  letter-spacing: 0;
  text-align: center;
}
.hl-tag-plain {
  background-color: #fff;
  border-width: 1px;
  border-style: solid;
}
</style>
